import api from "./api";

export const getParticipante = async (idParticipante) => {
    const response = await api.get(
        `/Participante/GetParticipanteViewById?idParticipante=${idParticipante}`
    );

    return response.data.data;
}
export const getsParticipanteAlergia = async (idParticipante) => {
    const response = await api.get(
        `/Participante/GetsParticipanteAlergiaViewById?idParticipante=${idParticipante}`
    );

    return response.data.data;
}
export const getsParticipantePersonaAutorizada = async (idParticipante) => {
    const response = await api.get(
        `/Participante/GetsParticipantePersonaAutorizadaViewById?idParticipante=${idParticipante}`
    );

    return response.data.data;
}
export const getsParticipanteNivelLenguaje = async (idParticipante) => {
    const response = await api.get(
        `/Participante/GetsParticipanteNivelLenguajeViewById?idParticipante=${idParticipante}`
    );

    return response.data.data;
}
export const deleteParticipanteAlergia = (idParticipante, numero) =>
    api.delete(
        "/Participante/DeleteParticipanteAlergia",{params: {idParticipante, numero}}
    );
export const deleteParticipantePersonaAutorizada = (idParticipante, numero) =>
    api.delete(
        "/Participante/DeleteParticipantePersonaAutorizada",{params: {idParticipante, numero}}
    );
export const deleteParticipanteNivelLenguaje = (idParticipante, numero) =>
    api.delete(
        "/Participante/DeleteParticipanteNivelLenguaje",{params: {idParticipante, numero}}
    );
export const postParticipanteWithDetails = (dataPost) =>
    api.post(
        "/Participante/AddUpdateParticipanteWithDetails",dataPost
    )

export const getsParticipantesResumenView = async (alfabetico = false, soloActivos = false, idFilial = 0) => {
    const response = await api.get('/Participante/GetsParticipantesResumenView', {
        params: { alfabetico, soloActivos, idFilial }
    });

    return response.data.data;
}

export const getsParticipantesResumenViewByMemberOrRelative = async (member, relative, idFilial = 0) => {
    const response = await api.get('/Participante/GetsParticipantesResumenViewByMemberOrRelative', {
        params: {
            member: member == null ? "" : member,
            relative: relative == null ? "" : relative,
            idFilial: idFilial || 0
        }
    });

    return response.data.data;
}


export const getFichaIngreso = async (idParticipante) => {
    const response = await api.get('/Participante/GetFichaIngreso', {
        params: { idParticipante }
    });
    return response.data.data;
};
